<span>
    <img src="../assets/iconsInApp/Success.png" height="20" width="20" class="me-2 mb-1" alt="Succesmelding" />{{data}}
</span>